<template>
  <svg
    viewBox="0 0 160 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1870_72614)">
      <mask
        id="mask0_1870_72614"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="25"
        width="41"
        height="37"
      >
        <path
          d="M0.272949 25.1735H40.6394V61.3279H0.272949V25.1735Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1870_72614)">
        <path
          d="M0.272461 36.4192L12.7716 61.3267L40.6403 25.1722L0.272461 36.4192Z"
          fill="#0086B7"
        />
      </g>
      <mask
        id="mask1_1870_72614"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="25"
        y="0"
        width="32"
        height="67"
      >
        <path
          d="M25.2939 0.999733H56.7772V66.85H25.2939V0.999733Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1870_72614)">
        <path
          d="M37.2877 66.8496L25.2939 1.00071L56.7772 61.5509L37.2877 66.8496Z"
          fill="#00A19A"
        />
      </g>
      <mask
        id="mask2_1870_72614"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="41"
        y="20"
        width="53"
        height="34"
      >
        <path
          d="M41.7854 20.6798H93.505V53.2258H41.7854V20.6798Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_1870_72614)">
        <path
          d="M60.9802 20.6795L41.7852 42.0028L93.506 53.2256L60.9802 20.6795Z"
          fill="#6859A3"
        />
      </g>
      <mask
        id="mask3_1870_72614"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="78"
        y="22"
        width="39"
        height="40"
      >
        <path
          d="M78.5759 22.7345H116.291V61.2141H78.5759V22.7345Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_1870_72614)">
        <path
          d="M83.9951 22.734L78.5752 61.215L116.29 41.5298L83.9951 22.734Z"
          fill="#7F2082"
        />
      </g>
      <mask
        id="mask4_1870_72614"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="92"
        y="20"
        width="29"
        height="59"
      >
        <path
          d="M92.8679 20.6392H120.133V78.9995H92.8679V20.6392Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_1870_72614)">
        <path
          d="M120.134 66.316L92.8672 79.0001L118.129 20.6398L120.134 66.316Z"
          fill="#ED6FA7"
        />
      </g>
      <mask
        id="mask5_1870_72614"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="115"
        y="46"
        width="24"
        height="20"
      >
        <path
          d="M115.589 46.7913H138.826V65.713H115.589V46.7913Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_1870_72614)">
        <path
          d="M115.589 46.7908L131.33 65.7125L138.825 49.0611L115.589 46.7908Z"
          fill="#DE2B64"
        />
      </g>
      <mask
        id="mask6_1870_72614"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="130"
        y="28"
        width="31"
        height="36"
      >
        <path
          d="M130.875 28.0817H160.273V63.5745H130.875V28.0817Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_1870_72614)">
        <path
          d="M130.875 28.082L138.594 63.5747L160.273 34.929L130.875 28.082Z"
          fill="#F59D27"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1870_72614">
        <rect
          width="160"
          height="80"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
